module.exports = __webpack_public_path__ + "img/horizontal_3_2_r_3009.7370efc0.png";